function convertToNumber(str: any) {
  // Remove commas and convert to number
  return parseFloat(str.replace(/,/g, ""));
}

export default convertToNumber;
